exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".divider {\r\n  border: 0.5px solid white;\r\n  height: 125px;\r\n}\r\n\r\n.truncate {\r\n  width: 280px;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n/*estilos enviados por XD*/\r\nfooter {\r\n  background: #3366CC;\r\n  padding: 35px 35px 10px 35px;\r\n  color: #FFFFFF;\r\n  opacity: 1;\r\n  font-size: 12px;\r\n}\r\n\r\n@media only screen and (max-width: 959px) {\r\n  [class*=\"divider\"] {\r\n    width: 100%;\r\n    height: 0px;\r\n  }  \r\n\r\n  .full-space-media-query {\r\n    width: 100%;\r\n  }\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/whuerfanoh/Documents/VSCode Projects/ng_identidadlogin/webapp/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = main